<ng-container *transloco="let t; prefix: 'address-editor'">
    <div [formGroup]="form"
        [ngClass]="compactLayout ? 'grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-6 w-full' : 'grid grid-cols-1 sm:grid-cols-3 gap-6 w-full'">

        <div [ngClass]="compactLayout ? 'col-span-full sm:col-span-1 lg:col-span-1' : 'col-span-full sm:col-span-1'">
            <mat-form-field floatLabel="auto" appearance="outline" class="w-full v2-form-field">
                <mat-label>{{t('POSTAL_CODE')}}</mat-label>
                <input [required]="required" [formControlName]="'postalCode'" matInput [imask]="postalCodeMask"
                    [unmask]="true" />
                <mat-error *ngIf="showMandatoryErrors && form.get('postalCode')?.hasError('required')">{{
                    t('POSTAL_CODE') + " é obrigatório"
                    }}</mat-error>
                <mat-error *ngIf="invalidPostalCode">
                    {{ t("InvalidPostalCode") }}
                </mat-error>
            </mat-form-field>
        </div>

        <div [ngClass]="compactLayout ? 'col-span-full sm:col-span-1 lg:col-span-2' : 'col-span-full sm:col-span-2'">
            <mat-form-field floatLabel="auto" appearance="outline" class="w-full v2-form-field">
                <mat-label>{{t('ADDRESS')}}</mat-label>
                <input [required]="required" [formControlName]="'formattedAddress'" matInput />
                <mat-error *ngIf="showMandatoryErrors && form.get('formattedAddress')?.hasError('required')">{{
                    t('ADDRESS') + " é obrigatório"
                    }}</mat-error>
            </mat-form-field>
        </div>

        <div [ngClass]="compactLayout ? 'col-span-full sm:col-span-1 lg:col-span-1' : 'col-span-full sm:col-span-1'">
            <mat-form-field floatLabel="auto" appearance="outline" class="w-full v2-form-field">
                <mat-label>{{t('NUMBER')}}</mat-label>
                <input [required]="required" [formControlName]="'number'" matInput [imask]="numberMask" [unmask]="true"
                    #addressNumber />
                <mat-error *ngIf="showMandatoryErrors && form.get('number')?.hasError('required')">{{
                    t('NUMBER') + " é obrigatório"
                    }}</mat-error>
            </mat-form-field>
        </div>

        <div [ngClass]="compactLayout ? 'col-span-full sm:col-span-1 lg:col-span-1' : 'col-span-full sm:col-span-2'">
            <mat-form-field floatLabel="auto" appearance="outline" class="w-full v2-form-field">
                <mat-label>{{t('COMPLEMENT')}}</mat-label>
                <input [formControlName]="'complement'" matInput />
            </mat-form-field>
        </div>

        <div [ngClass]="compactLayout ? 'col-span-full sm:col-span-1 lg:col-span-1' : 'col-span-full sm:col-span-1'">
            <mat-form-field floatLabel="auto" appearance="outline" class="w-full v2-form-field">
                <mat-label>{{t('NEIGHBORHOOD')}}</mat-label>
                <input [required]="required" [formControlName]="'neighborhood'" matInput />
                <mat-error *ngIf="showMandatoryErrors && form.get('neighborhood')?.hasError('required')">{{
                    t('NEIGHBORHOOD') + " é obrigatório"
                    }}</mat-error>
            </mat-form-field>
        </div>

        <div [ngClass]="compactLayout ? 'col-span-full sm:col-span-1 lg:col-span-1' : 'col-span-full sm:col-span-1'">
            <mat-form-field floatLabel="auto" appearance="outline" class="w-full v2-form-field">
                <mat-label>{{t('CITY')}}</mat-label>
                <input [required]="required" [formControlName]="'city'" matInput />
                <mat-error *ngIf="showMandatoryErrors && form.get('city')?.hasError('required')">{{
                    t('CITY') + " é obrigatório"
                    }}</mat-error>
            </mat-form-field>
        </div>

        <div [ngClass]="compactLayout ? 'col-span-full sm:col-span-1 lg:col-span-1' : 'col-span-full sm:col-span-1'">
            <mat-form-field floatLabel="auto" appearance="outline" class="w-full v2-form-field">
                <mat-label>{{t('ESTATE')}}</mat-label>
                <mat-select [formControlName]="'state'" [required]="required">
                    <mat-option>
                        <ngx-mat-select-search [placeholderLabel]="t('FIELD_STATE_ID')"
                            [formControl]="brazilianStatesFilter">
                            <div ngxMatSelectNoEntriesFound>
                                <span>{{ t('NO_STATE_LABEL') }}</span>
                            </div>
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="item.id" *ngFor="let item of statesDatasource">{{item.title}}</mat-option>
                </mat-select>
                <mat-error *ngIf="showMandatoryErrors && form.get('state')?.hasError('required')">{{
                    t('ESTATE') + " é obrigatório"
                    }}</mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="w-full flex flex-col gap-2 mt-2" *ngIf="showMap">
        <vui-progress-bar *ngIf="this.submitting" [mode]="'indeterminate'"></vui-progress-bar>
        <span *ngIf="!center">{{t('MAP_DEFAULT_TEXT')}}</span>

        <span *ngIf="center">{{t('PIN_HELPER_TEXT')}}</span>
        <div class="flex flex-col items-center md:w-1/2 sm:w-full">
            <google-map *ngIf="center" class="w-full block rounded-xl overflow-hidden" height="400px" width="100%"
                [center]="center" [zoom]="zoom">
                <map-marker [position]="center" [options]="markerOptions"
                    (mapDragend)="markerMoved($event)"></map-marker>
            </google-map>
        </div>
    </div>
</ng-container>